export function generateColors(count: number): string[] {
  // Define a set of distinct colors that are colorblind-friendly
  const baseColors = [
    '#0077BB', // blue
    '#EE7733', // orange
    '#009988', // teal
    '#CC3311', // red
    '#EE3377', // magenta
    '#33BBEE', // cyan
    '#BBBBBB', // grey
    '#7744CC', // purple
    '#000000', // black
    '#44BB99', // blue-green
  ];

  if (count <= baseColors.length) {
    return baseColors.slice(0, count);
  }

  // If we need more colors than in our base set,
  // generate additional ones using a perceptually distinct approach
  const colors = [...baseColors];
  for (let i = baseColors.length; i < count; i++) {
    // Use golden ratio for hue spacing, but adjust saturation and lightness
    // to maintain distinguishability
    const hue = (i * 137.508) % 360;
    // Alternate between two saturation/lightness combinations for better contrast
    const saturation = i % 2 === 0 ? 65 : 45;
    const lightness = i % 2 === 0 ? 55 : 65;
    colors.push(`hsl(${hue}, ${saturation}%, ${lightness}%)`);
  }

  return colors;
}
